import React, { Component } from 'react';
import _ from 'lodash';
import Logger from '../../util/Logger';
import Ideas from '../../models/Ideas';
import { ResponseSorts } from './ResponseSorts';
import './CommentsSummary.css';
import { commentApi } from "../../api/CommentApi";
import CommentCard from "./CommentCard";
import CommentsDetailList from "./CommentsDetailList"

export default class CommentsSummary extends Component {

  constructor (props) {
    super(props);

    const { event, idea } = props;
    if (!idea) {
      Logger.assert('Missing idea in CommentsSummary component');
    }

    if (!event) {
      Logger.assert('Missing event in CommentsSummary component');
    }

    this.state = {
      showComments: false,
      showDetails: false,
      topComments: this.getTopComments(props.initialComments)
    };
  }

  getTopComments = (comments) => {
    if (!Array.isArray(comments)) {
      return [];
    }

    return ResponseSorts.sortByMostPopularTopLevel(comments);
  };

  componentDidMount () {
    if (!Array.isArray(this.props.initialComments)) {
      this.fetchComments();
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.idea !== prevProps.idea && !Array.isArray(this.props.initialComments)) {
      this.fetchComments();
      return;
    }

    if (this.props.initialComments !== prevProps.initialComments &&
      Array.isArray(this.props.initialComments)) {
      this.setState({
        topComments: this.getTopComments(this.props.initialComments)
      });
    }
  }

  fetchComments = () => {
    const { idea } = this.props;
    commentApi
      .getComments(Ideas.getId(idea))
      .then(comments => {
        this.setState({
          topComments: this.getTopComments(comments)
        });
      })
      .catch(error => {
        Logger.error("Error loading comments for idea ", idea, error);
      });
  }

  handleToggleComments = () => {
    this.setState({
      showComments: !this.state.showComments
    });
  }

  handleToggleDetails = () => {
    this.setState({
      showDetails: !this.state.showDetails
    });
  }

  render () {
    const { idea } = this.props;
    return (
      <div className="comments-summary">
        { this.state.topComments.length > 0 ?
        <>
          <div className="row">
            <div class="col-md-8">
              <h3 onClick={this.handleToggleComments} style={{'cursor': 'pointer'}}>
                {this.state.topComments.length} {this.state.topComments.length > 1 ? 'Comments' : 'Comment'}
                <i className="material-icons">{!this.state.showComments ? 'expand_more' : 'expand_less'}</i>
              </h3>
            </div>
            {this.state.showComments &&
            <div class="col-md-4 hide-print">
              <div className="btn-group btn-group-fluid" data-toggle="buttons" role="group" onClick={this.handleToggleDetails}>
                <label className={'btn btn-outline-dark btn-sm' + (this.state.showDetails ? '':' active')}>
                  <input autocomplete="off" checked name="summary" type="radio"/>
                  <i className="material-icons">favorite_outline</i>
                </label>
                <label className={'btn btn-outline-dark btn-sm' + (this.state.showDetails ? ' active':'')}>
                  <input autocomplete="off" name="details" type="radio"/>
                  <i className="material-icons">list</i>
                </label>
              </div>
            </div>
            }
          </div>
          { this.state.showComments && 
          <div>
            { this.state.showDetails &&
              <CommentsDetailList idea={idea}/>
            }
            { !this.state.showDetails &&
            <div className="row">
              {
              _.map(this.state.topComments, (comment) => (
                !comment.deleted &&
                <div className="col-md-4">
                  <CommentCard comment={comment} truncate={true}/>
                </div>
              ))
              }
            </div>
            }
          </div>
          }
        </>
        :
          <div>No comment posted</div>
        }
      </div>
    );
  }
}
